import React, { Component } from 'react'
// import './Users.css'
import * as languageSettings from '../components/Language/languageSettings'
// import { getPermissions } from '../actions/permissions'
import { connect } from 'react-redux'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import Pagination from '../components/Common/Pagination'
import t from '../components/Language/language'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'
import whiteplus from '../images/whiteplus.png'
import Api from '../Api'
import { sortUsers } from '../actions/users'
import { getUserAccountList, setAccountSearchParams } from '../actions/userAccounts'
import AuthenticationService from '../components/Security/AuthenticationService'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import CommonLoader from '../components/Alerts/CommonLoader'
import { PopulateError } from '../components/Common/PopulateError'
import CommonSearch from '../components/Common/Search'

class MyAccountAdminContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      Ascending: true,
      offset: 0,
      data: [],
      recordCount: 10,
      filter: '',
      page: 0,
      showCommonLoader: false,
      search: '',
      sc: 'User_EmailAddress',
      st: 1,
      norecords: false,
      perPage: 10,
      sortType: 'ASC',
      isValid: true,
      errorMessage: [],
      forcePage: null,
      searchOptions: [
        { value: 'User_EmailAddress', name: 'Search username' },
        { value: 'Company_Name', name: 'Search company name' },
        { value: 'Company_AvanteCust_ID', name: 'Search Avante#' }
      ]
    }
    this.api = new Api()
    this.PageSizeValueDropdown = this.PageSizeValueDropdown.bind(this)
    this.PageClicked = this.PageClicked.bind(this)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    this.search = this.search.bind(this)

  }

  componentWillMount () {
    this.setState({ showCommonLoader: true })
    this.props.getUserAccountList(this.state, function (accountData) {
      this.setState({
        showCommonLoader: false,
        recordCount: accountData[0].Total
      })
    }.bind(this))
  }

  onSelectAlert (eventKey) {
    window.alert(`Alert from menu item.\neventKey: ${eventKey}`)
  }

  search (selectedFilter, criteria) {
    if (criteria === '') {
      window.location.href = '/admin/accounts'
    }
    this.setState({ showCommonLoader: true, forcePage: 0 })
    this.props.setAccountSearchParams({ 'filter': selectedFilter, 'criteria': criteria })
    this.props.getUserAccountList(this.state, function (accountData) {
      if (accountData.length) {
        this.setState({
          showCommonLoader: false,
          norecords: false,
          recordCount: accountData[0].Total,
          search: ''
        })
      } else {
        this.setState({
          showCommonLoader: false,
          norecords: true,
          recordCount: 0,
          search: ''
        })
      }
    }.bind(this))
  }

  PageSizeValueDropdown (perPage) {
    this.setState({
      perPage,
      showCommonLoader: true
    })
    let input = this.state
    input.perPage = perPage !== 0 ? perPage : 20000000
    input.page = 1
    input.offset = 0
    this.props.getUserAccountList(input, function (accountData) {
      if (accountData.length) {
        this.setState({
          offset: 0,
          page: 1,
          showCommonLoader: false,
          recordCount: accountData[0].Total
        })
      } else {
        this.setState({
          norecords: true,
          recordCount: 0,
          showCommonLoader: false
        })
      }
    }.bind(this))
    // this.state.offset = Math.ceil((this.state.offset / 10) * pageSize)
    this.state.offset = 0
  }

  PageClicked (value) {
    let input = this.state
    let pageNumber = (value / this.state.perPage) + 1
    this.setState({
      showCommonLoader: true,
      page: pageNumber,
      forcePage: null
    })
    input.page = pageNumber
    this.props.getUserAccountList(input, function (accountData) {
      this.setState({
        showCommonLoader: false,
        recordCount: accountData[0].Total
      })
    }.bind(this))
    if (value === null) {
      return this.state.offset
    } else {
      this.state.offset = value
      return this.state.offset
    }
  }

  handleSearchChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  handleCriteria (e) {
    this.setState({
      [e.target.name]: e.target.value,
      page: 1,
      offset: 0
    })
  }

  sortAccounts (e) {
    let sc = e.target.id
    let sortType = this.state.Ascending ? 'DESC' : 'ASC'
    let input = this.state
    input.sc = e.target.id
    input.st = sortType === 'DESC' ? 0 : 1
    this.setState({
      showCommonLoader: true,
      sc: sc,
      sortType: sortType
    })
    this.props.getUserAccountList(input, function (accountData) {
      this.setState({
        showCommonLoader: false,
        recordCount: accountData[0].Total,
        sc: sc,
        sortType: sortType
      })
    }.bind(this))
    this.state.Ascending = !this.state.Ascending
    this.setState(this.state)
  }

  send (e) {
    this.setState({
      showLoader: true
    })
    let url = Config.apiBaseUrl + 'api/store/unRegisterDevicesSearch?reportType=csv'
    this.api.postData(url, this.state.rawCarRequest, data => {
      if (data.status) {
        this.setState({
          showLoader: false
        })
        this.props.history.push('/emailSent', data.data)
      }
    }, error => {
      console.log(error)
    })
  }

  handleTab (e) {
    this.setState({
      showCommonLoader: true
    })
    const { language } = this.state
    const value = e.target.name
    let url = null
    let email = null
    email = this.authService.getAdminProfile().unique_name
    if (value === 'expired') {
      url = Config.apiBaseUrl + CommonConstants.apiUrls.getExpiredAccounts + email
    }
    if (value === 'renewal') {
      url = Config.apiBaseUrl + CommonConstants.apiUrls.getRenewalAccounts + email
    }
    if (value === 'free') {
      url = Config.apiBaseUrl + CommonConstants.apiUrls.getFreeAccounts + email
    }
    this.api.getData(url, result => {
      if (result.status) {
        if (window.location.pathname === '/admin/accounts') {
          this.setState({
            showCommonLoader: true
          })
          this.props.history.push('/emailSent')
        }
      } else {
        let errors = []
        errors.push(t[language].ReportsNoRecordsFound)
        this.setState({ isValid: false, errorMessage: errors })
      }
    })
  }
  renderUsers () {
    if (this.props.accountList) {
      let storeRows = this.props.accountList.userAccounts.map(function (account, index) {
        let editUrl = '/admin/account?type=' + account.Company_Type + '&' + 'uuid=' + account.User_UID
        let distributorEditUrl = '/admin/account?type=distributor&useruid=' + account.Distributor_UID
        return (
          <Tr className='tdata clear'>
            <Td className='view_details'>
              <a href={editUrl} className='opener view_details'>
                <span translate='' key='viewedit'>View/Edit</span> <br />
                <span translate='' key='settingsStoresDetails'>
                  Users
                </span>
              </a>
            </Td>
            <Td className='posRel'>
              {account.User_EmailAddress.substring(0, 17)}
              <a className={'ellipse ' + (account.User_EmailAddress.length > 17 ? '' : 'hide')}>
                ...
                <span className='tooltipCustomAdmin'>{account.User_EmailAddress}</span>
              </a>
            </Td>
            <Td className='posRel'>
              {account.Company_Name.substring(0, 17)}
              <a className={'ellipse ' + (account.Company_Name.length > 17 ? '' : 'hide')}>
                ...
                <span className='tooltipCustomAdmin'>{account.Company_Name}</span>
              </a>
            </Td>
            <Td className='posRel'>
              {account.Company_AvanteCust_ID.substring(0, 17)}
              <a className={'ellipse ' + (account.Company_AvanteCust_ID.length > 17 ? '' : 'hide')}>
                ...
                <span className='tooltipCustomAdmin'>{account.Company_AvanteCust_ID}</span>
              </a>
            </Td>
            {(account.Distributor_UID && account.Distributor_UID !== undefined && account.Distributor_UID !== null)
              ? <Td><a href={distributorEditUrl} className='opener view_details'> {account.distributor}</a></Td> : <Td>{account.distributor}</Td>
            }
            {/* <Td>{account.Account_Subscription_ID}</Td>  */}
            {/* Add Subscription_Name */}
            <Td>{account.Subscription_Name}</Td>
            <Td>{ (account.Account_StartDate) ? moment(account.Account_StartDate.replace('Z', '')).format('MM/DD/YYYY') : ''}</Td>
            <Td>{ (account.Account_EndDate) ? moment(account.Account_EndDate.replace('Z', '')).format('MM/DD/YYYY') : '' }</Td>
          </Tr>
        )
      })
      return storeRows
    } else {
      return ''
    }
  }
  renderAddon () {
    let recordCount = this.state.recordCount
    let pageCount = Math.ceil(this.state.recordCount / this.state.perPage)
    let sortParams = this.state
    return (
      <div className='admin-accnt'>
        <h3 className='clear'>Accounts</h3>
        <div className='links'>
          <a name='account' href={'/admin/account?type=Franchise'} ><img src={whiteplus} className='whiteplus' alt='plus' />Add an Account</a>
          <a name='expired' onClick={(e) => this.handleTab(e)} >Expired Accounts</a>
          <a name='renewal' onClick={(e) => this.handleTab(e)} >Account Renewals</a>
          <a name='free' onClick={(e) => this.handleTab(e)} >Free Accounts</a>
          <CommonSearch onSearch={this.search}
            searchOptions={this.state.searchOptions} />
        </div>
        <section className='users listingAdmin'>
          <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} />
          <div className={'settings forms ' + (!this.state.showCommonLoader ? '' : 'hidden')}>
            <div className='settings_plug clear'>
              <div className='settings_list'>
                <div className='ctable'>
                  <Table>
                    <Thead>
                      <Tr className='theader clear'>
                        <Th />
                        <Th id='User_EmailAddress' className={(sortParams.sc === 'User_EmailAddress' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'User_EmailAddress' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='User_EmailAddress' onClick={(e) => { this.sortAccounts(e) }}>Username</span></a>
                        </Th>
                        <Th className={(sortParams.sc === 'Company_Name' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'Company_Name' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='Company_Name' onClick={(e) => { this.sortAccounts(e) }}>Company Name</span></a>
                        </Th>
                        <Th className={(sortParams.sc === 'Company_AvanteCust_ID' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'Company_AvanteCust_ID' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='Company_AvanteCust_ID' onClick={(e) => { this.sortAccounts(e) }}>Avante #</span></a>
                        </Th>
                        <Th className={(sortParams.sc === 'distributor' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'distributor' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='distributor' onClick={(e) => { this.sortAccounts(e) }}>Distributor</span></a>
                        </Th>
                        <Th className={(sortParams.sc === 'Subscription_Name' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'Subscription_Name' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='Subscription_Name' onClick={(e) => { this.sortAccounts(e) }}>Subscription Type</span></a>
                        </Th>
                        <Th className={(sortParams.sc === 'Account_StartDate' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'Account_StartDate' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='Account_StartDate' onClick={(e) => { this.sortAccounts(e) }}>Start Date</span></a>
                        </Th>
                        <Th className={(sortParams.sc === 'Account_EndDate' && sortParams.sortType === 'DESC') ? 'actcol' : ((sortParams.sc === 'Account_EndDate' && sortParams.sortType === 'ASC') ? 'actcold' : '')}>
                          <a><span id='Account_EndDate' onClick={(e) => { this.sortAccounts(e) }}>End Date</span></a>
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody className={(this.state.norecords ? 'hide' : '')}>
                      {this.renderUsers()}
                    </Tbody>
                    <Tbody className={(this.state.norecords ? '' : 'hide')}>
                      <tr className='tdata clear'><td colspan='8' className='accounts_table_noUsers'> <h3 className='noUsers'>No Users Found</h3> </td></tr>
                    </Tbody>
                  </Table>
                  <div>
                    <Pagination
                      perPage={this.state.perPage}
                      PageSizeValueChange={this.PageSizeValueDropdown}
                      offset={this.PageClicked}
                      recordCount={recordCount}
                      pageCount={pageCount}
                      offSetValue={this.state.offset}
                      forcePage={this.state.forcePage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }

  renderMain () {
    return (
      <div className='reportsTabs'>
        <div className='status-messages'>
          <div className={'alert alert-danger errors ' + (this.state.isValid ? 'hide' : 'show')} >
            <ul> <PopulateError errors={this.state.errorMessage} /></ul>
          </div>
        </div>

        {this.renderAddon()}
      </div>
    )
  }
  render () {
    if (this.authService.isAdmin()) {
      return this.renderMain()
    } else {
      window.location.href = '/myAccount'
      return <div />
    }
  }
}
function mapStateToProps (state) {
  return {
    accountList: state.userAccounts,
    users: state.users
    // permissions: state.permissions
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      sortUsers: sortUsers,
      // getPermissions: getPermissions,
      getUserAccountList,
      setAccountSearchParams: setAccountSearchParams
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(MyAccountAdminContainer)



// WEBPACK FOOTER //
// ./src/containers/MyAccountAdmin.js